import {
  index as baseIndex,
  getFromId as baseGetFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
* Get a list of call reports based on a pagination system
*
* @param page the page requested
* @param itemPerPage the number of item in the page requested
*/
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('call_reports', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
* Get a single call report based on his ID
*
* @param id the of the call report requested
*/
export function getFromId(id) {
  return baseGetFromId('call_reports', id);
}

/**
* Get a single call report based on his ID
*
* @param id the of the call report requested
*/
export function getIdentificationFromId(id) {
  return baseGetFromId('call_reports', id, 'identification');
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
* Create a new call report
*
* @param data the new data of the call report
*/
export function newItem(data) {
  return baseNewItem('call_reports', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all call reports to serve in a dropdown form choice
 */
export function fetchCallReports(search) {
  return baseIndex('call_reports', 1, 0, search, 'ASC', 'identification');
}
